import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "app-main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_aside = _resolveComponent("layout-aside");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_layout_header = _resolveComponent("layout-header");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_aside, {
      width: _ctx.leftMenuWidth
    }, {
      default: _withCtx(() => [_createVNode(_component_layout_aside)]),
      _: 1
    }, 8, ["width"]), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_header, null, {
        default: _withCtx(() => [_createVNode(_component_layout_header)]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "router-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [!_ctx.$route.fullPath.includes('lcProject') ? (_openBlock(), _createBlock(_KeepAlive, {
            key: 0
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024)) : (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 1
          }))]),
          _: 2
        }, 1024)]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  });
}